import { normalizeUrl } from '../../utils/url';
import api from '../api';

/**
 * Fetch HTML content from a cell hover URL.
 * Endpoint returns JSON with a `content` field (200) or 204 with no body.
 * @param {string} url - The hover URL to fetch
 * @returns {Promise<CellHoverContent>}
 */
export const getCellHoverContent = async (url) => {
  const response = await api.get(normalizeUrl(url));

  if (response.status === 204) {
    return null;
  }

  const content = response.data?.content;

  if (typeof content !== 'string' || content.trim() === '') {
    return null;
  }

  return content;
};
